import { useContext } from 'react';

import { HotelContext } from 'app/context/HotelContext/HotelContext';
import { TaskCenterContext } from 'app/context/TaskCenterContext/TaskCenterContext';
import type { ExtranetRoom } from 'app/typings/packages';
import { assertNever } from 'app/utils/typing';

import { AutoInventoryModal } from '../../../../ExtranetInventory/Legacy/AutoInventory/AutoInventoryModal/AutoInventoryModal';
import { PricingRule } from '../../../../ExtranetInventory/Legacy/PricingRule/PricingRule';
import { BillingInformationModal } from '../../../BillingInformation/BillingInformationModal';
import { ExtraAddOn } from '../../../ExtraAddOn/Legacy/ExtraAddOn';
import { ExtraBedModal } from '../../../ExtraBed/Modal/Legacy/ExtraBedModal';
import { ExtraGuestModal } from '../../../ExtraGuest/ExtraGuest';
import type { BedTaskInformation, Task } from '../Types';
import { TaskName } from '../Types';

type RenderModalProps = {
  task: Task;
  onCompleteTask: () => void;
  rooms?: ExtranetRoom[];
};

export const RenderModal = ({
  task,
  onCompleteTask,
  rooms,
}: RenderModalProps) => {
  const { openTask, clearOpenTask } = useContext(TaskCenterContext);
  const { hotelInfo } = useContext(HotelContext);

  switch (task.taskName) {
    case TaskName.LastMinutePricingRule:
    case TaskName.PricingRule:
      return (
        <PricingRule
          onClose={() => clearOpenTask()}
          isOpen={task.taskName === openTask}
          onCompleteTask={onCompleteTask}
        />
      );
    case TaskName.BabyCot:
    case TaskName.GuestBed:
      return rooms ? (
        <ExtraBedModal
          bedTypeId={(task as Extract<Task, BedTaskInformation>).categoryId}
          rooms={rooms}
          isOpen={task.taskName === openTask}
          onCompleteTask={onCompleteTask}
        />
      ) : (
        <></>
      );
    case TaskName.AttractExtraGuests:
    case TaskName.ConfigureChildPrice:
    case TaskName.AttractSingleGuests:
      return rooms ? (
        <ExtraGuestModal
          taskName={task.taskName}
          isOpen={task.taskName === openTask}
          onCompleteTask={onCompleteTask}
          rooms={rooms}
        />
      ) : (
        <></>
      );

    case TaskName.EarlyCheckin:
    case TaskName.LateCheckout:
      return (
        <ExtraAddOn
          isOpen={task.taskName === openTask}
          task={task}
          onCompleteTask={onCompleteTask}
        />
      );
    case TaskName.AutoInventory:
      return (
        <AutoInventoryModal
          hasAutoInventoryActivated={hotelInfo?.stockScrapperEnabled ?? false}
          onClose={clearOpenTask}
          isAutoInventoryModalOpen={task.taskName === openTask}
        />
      );
    case TaskName.BillingInformation:
      return (
        <BillingInformationModal
          isOpen={task.taskName === openTask}
          source="task center"
          onClose={clearOpenTask}
          onSaved={onCompleteTask}
        />
      );
    case TaskName.VirtualCards:
      return <></>;
    default:
      assertNever(task.taskName);
  }
};
